import { Component, HostBinding } from '@angular/core';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  // ...
} from '@angular/animations';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass'],
  animations: [
    trigger('rightLeft', [
      state('right', style({
        top: '0',
        transform: 'rotate(0deg)'
      })),
      state('left', style({
        top: '10px',
        transform: 'rotate(135deg)'
      })),
      transition('left => right', [
        animate('0.25s')
      ]),
      transition('right => left', [
        animate('0.25s')
      ]),
    ]),
    trigger('middleOut', [
      state('middle', style({
        top: '10px',
        opacity: '1',
        left: '0',
      })),
      state('out', style({
        top: '10px',
        opacity: '0',
        left: '-60px'
      })),
      transition('middle => out', [
        animate('0.25s')
      ]),
      transition('out => middle', [
        animate('0.25s')
      ])
    ]),
    trigger('leftRight', [
      state('left', style({
        top: '20px',
        transform: 'rotate(0deg)'
      })),
      state('right', style({
        top: '10px',
        transform: 'rotate(-135deg)'
      })),
      transition('right => left', [
        animate('0.25s')
      ]),
      transition('left => right', [
        animate('0.25s')
      ])
    ])
  ]
})
export class AppComponent {
  isOpen = false;
  showContact=false;

  links: any[] = [
      {name: 'Startseite', path: '/home'},
      {name: 'Leistungen', path: '/leistungen'},
      {name: 'Untersuchungen', path: '/untersuchungen'},
      {name: 'Vasektomie', path: '/vasektomie'},
      {name: 'Praxis', path: '/praxis'},
      {name: 'Kontakt', path: '/kontakt'},
      {name: 'Impressum', path: '/impressum'}
      ];
}
